import { EventTypes, track } from '@mc/track-event'

export const trackCtaClicked = (copy) => {
  track(EventTypes.ARTICLE_PAGE_CLICK, {
    location: 'seo_articles_learn_from_the_best_cta',
    linkCopy: copy,
    textTag: 'a',
  })
}
